export default __webpack_public_path__ + "static/media/icon-cg.8562cbe2.png";